<script lang="ts" setup>

import {computed} from "vue";

export interface Props {
    label: string;
    limit: number;
    current: number;
}

const props = defineProps<Props>();

const currentPercentage = computed(() => {
    return Math.min((props.current * 100) / props.limit, 100)
})

</script>

<template>
    <div class="">
        <div class="flex justify-between mb-1">
            <span class="">{{ props.label }}</span>
            <span class="">{{ props.current }} / {{ props.limit }}</span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-2.5">
            <div class="bg-indigo-600 h-2.5 rounded-full" :style="{width: currentPercentage + '%'}"></div>
        </div>
    </div>
</template>